import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.show-empty-applicable', () => {
  void import('./internal/empty-applicable-block').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.left-shared-menu', () => {
  void import('./internal/left-shared-menu').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.note-photos-form', () => {
  void import('./internal/note-photos-form').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.ransack-filter', () => {
  void import('./internal/ransack-filter').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.notifications', () => {
  void import('./internal/restricted-message').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.scout-reports-widget-map', () => {
  void import('./internal/scout-reports-map').then(({ default: Component }) => Component());
});
